import * as React from 'react';

const AddIcon = ({fillColor = '#fff'}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={12} height={12}>
    <path
      fill={fillColor}
      d="M5.996 11.834a.61.61 0 0 1-.621-.625V6.625H.792a.603.603 0 0 1-.446-.18.61.61 0 0 1-.18-.448.61.61 0 0 1 .625-.621h4.584V.791c0-.177.06-.326.18-.445a.61.61 0 0 1 .449-.18.61.61 0 0 1 .621.625v4.583h4.583c.177 0 .326.06.446.181.12.12.18.27.18.448s-.06.326-.18.444a.61.61 0 0 1-.446.177H6.625v4.584c0 .177-.06.325-.18.445a.61.61 0 0 1-.449.18Z"
    />
  </svg>
);

export default AddIcon;
